query ContractPaymentsList(
  $page: Int
  $rowsPerPage: Int
  $filter: ContractPaymentsFilterInput
) {
  contractPayments(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      periodFrom
      periodTo
      invoiceDate
      expiredAt
      paidAt
      status
      expired
      amount {
        value
        currency
      }
      invoiceAmount {
        value
        currency
      }
      invoice {
        number
        issuedAt
      }
      invoiceUrl
      createdAt
    }
  }
}
